module.exports = __webpack_public_path__ + "static/img/connect02.e79282d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/connect02.png
// module id = O9+i
// module chunks = 1